export default __webpack_public_path__ + "static/media/Arte_305_Fondo_V3.b35ec576.png";